import '../../styles/sections/glossary.scss';

class GlossarySearch extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.getAttribute('data-section-id');
    this.glossaryItems = JSON.parse(document.querySelector('[data-glossary-items]').innerHTML)?.glossary_items;
    this.searchInput = this.querySelector('[data-glossary-search-input]');
    this.listEl = document.querySelector(`[data-glossary-list=${this.sectionId}]`);
    this.lettersNav = document.querySelector(`[data-glossary-letters-nav=${this.sectionId}]`);
    this.lettersSelect = document.querySelector(`[data-glossary-letters-select=${this.sectionId}]`);

    this.searchInput.addEventListener('input', this.onSearchInputChange.bind(this));

    this.lettersSelect.addEventListener('change', (event) => {
      const letter = event.target.value;
      const section = document.querySelector(letter);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  onSearchInputChange() {
    const query = this.searchInput.value.toLowerCase();

    this.listEl.classList.add('loading');

    const filtered = this.glossaryItems.filter(glossaryItem => {
      return glossaryItem.name.toLowerCase().includes(query);
    });

    const grouped = {};

    // Group by first letter
    filtered.forEach(item => {
      let letter = item.name.charAt(0).toUpperCase();
      if (!letter.match(/[A-Z]/)) {
        letter = '#';
      }
      if (!grouped[letter]) {
        grouped[letter] = [];
      }
      grouped[letter].push(item);
    });

    this.renderResults(grouped);

    this.updateLettersNav(Object.keys(grouped));
  }

  renderResults(grouped) {
    if (!this.listEl) return;

    this.listEl.innerHTML = '';

    const sortedLetters = Object.keys(grouped).sort((a, b) => {
      if (a === '#') return 1; // Move '#' to the end
      if (b === '#') return -1; // Move '#' to the end
      return a.localeCompare(b);
    });

    sortedLetters.forEach(letter => {
      const section = document.createElement('div');
      if (letter === '#') {
        section.setAttribute('id', `${this.sectionId}-letter-symbol`);
      } else {
        section.setAttribute('id', `${this.sectionId}-letter-${letter}`);
      }
      section.setAttribute('class', 'glossary__letter-wrapper');

      const heading = document.createElement('span');
      heading.classList.add('h4');
      heading.textContent = letter;

      const entriesWrapper = document.createElement('div');
      entriesWrapper.classList.add('glossary__entries');

      const cardsHTML = grouped[letter].map(glossaryItem => `
        <div class="glossary__card">
          <${glossaryItem.collection_handle ? `a href="/collections/${glossaryItem.collection_handle}"` : 'div'} class="glossary__card-image">
            ${glossaryItem.logo
              ? `${glossaryItem.logo}`
              : (glossaryItem.image || glossaryItem.fallback_image
                ? `<img src="${glossaryItem.image ? glossaryItem.image : glossaryItem.fallback_image}" alt="${glossaryItem.name}" loading="lazy" />`
                : '')}
          </${glossaryItem.collection_handle ? `a` : 'div'}>
          <div class="glossary__card-name body--medium">
            <${glossaryItem.collection_handle ? `a href="/collections/${glossaryItem.collection_handle}"` : 'div'}>
              ${glossaryItem.name}
            </${glossaryItem.collection_handle ? `a` : 'div'}>
          </div>
          ${glossaryItem.description ? `
            <div class="glossary__card-description body--small">
              ${glossaryItem.description}
            </div>
          `: ''}
        </div>
        `).join('');

      entriesWrapper.innerHTML = cardsHTML;

      section.appendChild(heading);
      section.appendChild(entriesWrapper);
      this.listEl.appendChild(section);
    });

    this.listEl.classList.remove('loading');
  }

  updateLettersNav(activeLetters) {
    if (this.lettersSelect) {
      const options = this.lettersSelect.querySelectorAll('option');

      options.forEach(option => {
        const letter = option.text.toUpperCase();
        if (activeLetters.includes(letter)) {
          option.disabled = false;
        } else {
          option.disabled = true;
        }
      });
    }

    if (this.lettersNav) {
      const allLinks = this.lettersNav.querySelectorAll('[data-glossary-letter]');
      allLinks.forEach(link => {
        const letter = link.textContent.trim().toUpperCase();
        if (activeLetters.includes(letter)) {
          link.classList.remove('is-disabled');
          if (letter === '#') {
            link.setAttribute('href', `#${this.sectionId}-letter-symbol`);
          }
          else {
            link.setAttribute('href', `#${this.sectionId}-letter-${letter}`);
          }
          link.removeAttribute('aria-disabled');
        } else {
          link.classList.add('is-disabled');
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
        }
      });
    }
  }
}

customElements.define('glossary-search', GlossarySearch);
